<template>
<div class="float-bottom-area" v-bind="$attrs" v-on="$listeners">
  <slot></slot>
</div>
</template>

<script>
export default {
  name: "FloatBottom"
}
</script>

<style lang="scss" scoped>
.float-bottom-area {
  position: fixed;
  width: 100%;
  bottom: 0;
  padding-bottom: 40px;
}
</style>